// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__QaCax","sub_container":"WordGameLayout_sub_container__OXZV9"};